import { db } from '../firebase';
import { getBackendError } from 'common/utils';

const categoryMapper = (documentSnapshot) => {
  const { name, lead } = documentSnapshot.data();

  return {
    alias: documentSnapshot.id,
    name,
    lead,
  };
};

const categoryListMapper = (docs) => {
  return docs.map((documentSnapshot) => categoryMapper(documentSnapshot));
};

export const getCategoriesList = async () => {
  return new Promise((resolve, reject) => {
    db
      .collection('category')
      .orderBy('name.ru')
      .get()
      .then((querySnapshot) => resolve(categoryListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateCategory = async (
  id,
  nameEn,
  nameRu,
  nameUk,
  namePl,
  nameIt,
  nameEs,
  namePt,
  leadEn,
  leadRu,
  leadUk,
  leadPl,
  leadIt,
  leadEs,
  leadPt,
  ) => {
  return new Promise((resolve, reject) => {
    db
      .collection('category')
      .doc(id)
      .update({
        name: {
          en: nameEn,
          ru: nameRu,
          uk: nameUk,
          pl: namePl,
          it: nameIt,
          es: nameEs,
          pt: namePt,
        },
        lead: {
          en: leadEn,
          ru: leadRu,
          uk: leadUk,
          pl: leadPl,
          it: leadIt,
          es: leadEs,
          pt: leadPt,
        }
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};
